import React from 'react'
import * as images from 'src/assets/images'
import { useTranslation } from 'react-i18next'
import styles from './ProjectKindContent.module.scss'
import { Project } from 'src/core/models'
import Image from 'next/image'
import { Tooltip } from 'antd'

interface PropsType { project: Project }

const ProjectKindContent: React.FC<PropsType> = ({ project }: PropsType) => {
  const { t } = useTranslation()
  const projectName = project.name

  const projectKindField = {
    compensation: { image: images.compensationCircle, label: t('Projects.Kind.Compensation') },
    contribution: { image: images.contributionCircle, label: t('Projects.Kind.Contribution') },
    energy: { image: images.energyCircle, label: t('Projects.Kind.Energy') },
    biodiversity: { image: images.biodiversityCircle, label: t('Projects.Kind.Biodiversity') },
    carbon_forward: { image: images.compensationCircle, label: t('Forward.Title') }
  }[project?.kind]

  const span = (className: string, label: string) => (
    <span className={className}>{label}</span>
  )

  return (
    <div className={styles.content}>
      {/* Project Kind */}
      <div>
        <Image
          src={projectKindField.image}
          className={styles.image}
          width={15} height={15}
          alt={`circle-${project?.kind}`}
        />
        {span(styles.kind, projectKindField.label)}
      </div>

      {/* Project Name */}
      {projectName.length >= 50 ? <Tooltip title={projectName} color='cyan'>
        {span(styles.projectName, projectName)}
      </Tooltip>: <>{span(styles.auxProjectName, projectName)}</>}
    </div>
  )
}

export default ProjectKindContent
